export default __webpack_public_path__ + "114cd18b478088cff3e422700eeea537.woff2";